import React from 'react';
import Select, { SingleValue, StylesConfig } from 'react-select';

import styles from './index.module.scss';

type Option = { label: JSX.Element; value: number };

interface Props {
  options: Array<Option>;
  activeOptionIndex: number;
  selectOption: (index: number) => void;
}

function PersonalizationDropDown({ options, activeOptionIndex, selectOption }: Props) {
  const activeOption = options[activeOptionIndex];

  function onSelect(option: SingleValue<Option>) {
    if (option) {
      selectOption(option.value);
    }
  }
  const customStyles: StylesConfig<Option, false> = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: '8px',
      padding: '2px 4px',
      cursor: 'pointer',
      fontSize: '16px',
      lineHeight: '24px',
      border: state.isFocused ? '1px solid #212121' : '1px solid #999',
      outline: state.isFocused ? '1px solid #212121' : 'none',
      boxShadow: 'none',
      fontWeight: 500,
      '&:hover': {
        borderColor: !state.isFocused ? '#999' : 'none',
      },
    }),
    menuPortal: (provided) => ({
      ...provided,
      marginTop: '-4px',
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#f7f7f7' : 'transparent',
      color: '#212121',
      cursor: 'pointer',
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 500,
      padding: '12px',
      '&:active': {
        backgroundColor: '#f2f2f2',
      },
    }),
  };

  return (
    <Select
      placeholder=""
      options={options}
      onChange={onSelect}
      className={styles.personalizationDropdown}
      classNamePrefix="personalizationDropdown"
      value={activeOption}
      isSearchable={false}
      styles={customStyles}
      menuPortalTarget={document.body}
    />
  );
}
export default React.memo(PersonalizationDropDown);
